import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export default {
  __name: 'HamburgerButton',
  props: {
    open: Boolean
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["ham-menu-button", {
          'open': props.open
        }]),
        tabindex: "0"
      }, _cache[0] || (_cache[0] = [_createElementVNode("div", null, null, -1), _createElementVNode("div", null, null, -1), _createElementVNode("div", null, null, -1)]), 2);
    };
  }
};